var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 115,
    viewBox: "0 0 161 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1582_23)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1582_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.312 23.5626C102.219 21.6566 104.804 20.5859 107.5 20.5859C110.196 20.5859 112.782 21.6566 114.688 23.5626",
    stroke: "#459AA4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1221 16.3719C95.0102 14.4836 97.2518 12.9858 99.7188 11.9639C102.186 10.942 104.83 10.416 107.5 10.416C110.171 10.416 112.815 10.942 115.282 11.9639C117.749 12.9858 119.99 14.4836 121.878 16.3719",
    stroke: "#459AA4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 29,
    r: 2,
    stroke: "#459AA4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 107H66",
    stroke: "#459AA4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 50.667H57.3333",
    stroke: "#459AA4",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 68H57.3333",
    stroke: "#459AA4",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 85.333H57.3333",
    stroke: "#459AA4",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.667 50.667H79.0003",
    stroke: "#459AA4",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.667 68H79.0003",
    stroke: "#459AA4",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.667 107V37.6667C35.667 35.37 36.5813 33.1643 38.2063 31.5393C39.8313 29.9143 42.037 29 44.3337 29H87.667C89.9637 29 92.1693 29.9143 93.7943 31.5393C95.4193 33.1643 96.3337 35.37 96.3337 37.6667V68",
    stroke: "#459AA4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9875 84.9755C84.6265 82.3415 88.3735 82.3415 89.0125 84.9755C89.1084 85.3712 89.2963 85.7387 89.5611 86.048C89.8258 86.3573 90.1598 86.5998 90.536 86.7556C90.9121 86.9115 91.3197 86.9763 91.7257 86.9448C92.1316 86.9133 92.5244 86.7865 92.872 86.5745C95.1865 85.1645 97.837 87.8135 96.427 90.1295C96.2153 90.477 96.0887 90.8695 96.0573 91.2752C96.0259 91.6808 96.0906 92.0882 96.2463 92.4641C96.4019 92.84 96.6441 93.1739 96.9531 93.4386C97.2621 93.7033 97.6292 93.8914 98.0245 93.9875C100.659 94.6265 100.659 98.3735 98.0245 99.0125C97.6288 99.1084 97.2613 99.2963 96.952 99.5611C96.6427 99.8258 96.4002 100.16 96.2444 100.536C96.0885 100.912 96.0237 101.32 96.0552 101.726C96.0867 102.132 96.2135 102.524 96.4255 102.872C97.8355 105.186 95.1865 107.837 92.8705 106.427C92.523 106.215 92.1305 106.089 91.7248 106.057C91.3192 106.026 90.9118 106.091 90.5359 106.246C90.16 106.402 89.8261 106.644 89.5614 106.953C89.2967 107.262 89.1086 107.629 89.0125 108.025C88.3735 110.659 84.6265 110.659 83.9875 108.025C83.8916 107.629 83.7037 107.261 83.4389 106.952C83.1742 106.643 82.8402 106.4 82.464 106.244C82.0879 106.089 81.6803 106.024 81.2743 106.055C80.8684 106.087 80.4756 106.214 80.128 106.426C77.8135 107.836 75.163 105.186 76.573 102.87C76.7847 102.523 76.9113 102.13 76.9427 101.725C76.9741 101.319 76.9094 100.912 76.7537 100.536C76.5981 100.16 76.3559 99.8261 76.0469 99.5614C75.7379 99.2967 75.3708 99.1086 74.9755 99.0125C72.3415 98.3735 72.3415 94.6265 74.9755 93.9875C75.3712 93.8916 75.7387 93.7037 76.048 93.4389C76.3573 93.1742 76.5998 92.8402 76.7556 92.464C76.9115 92.0879 76.9763 91.6803 76.9448 91.2743C76.9133 90.8684 76.7865 90.4756 76.5745 90.128C75.1645 87.8135 77.8135 85.163 80.1295 86.573C81.6295 87.485 83.5735 86.678 83.9875 84.9755Z",
    stroke: "#459AA4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 96.5C82 97.6935 82.4741 98.8381 83.318 99.682C84.1619 100.526 85.3065 101 86.5 101C87.6935 101 88.8381 100.526 89.682 99.682C90.5259 98.8381 91 97.6935 91 96.5C91 95.3065 90.5259 94.1619 89.682 93.318C88.8381 92.4741 87.6935 92 86.5 92C85.3065 92 84.1619 92.4741 83.318 93.318C82.4741 94.1619 82 95.3065 82 96.5Z",
    stroke: "#459AA4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1582_23",
    x: 21,
    y: 8.41602,
    width: 106.878,
    height: 111.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1582_23"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1582_23",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1582_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 115,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBms);
export default __webpack_public_path__ + "static/media/BMS.e7a29e79cc032981b451185fa999c7b0.svg";
export { ForwardRef as ReactComponent };